export enum MerchantCreatedReturnLabelChargeDefault {
  AUTO = "auto",
  ON = "on",
  OFF = "off",
}
